import {
    CORE_SEARCH_ROOM_REQUEST,
    CORE_SEARCH_ROOM_SUCCESS,

    O365_SUGGEST_ROOM_REQUEST,
    O365_SUGGEST_ROOM_SUCCESS,

    CORE_LOAD_ROOMS_REQUEST,
    CORE_LOAD_ROOMS_SUCCESS,

    CORE_GET_ROOM_INFO_REQUEST,
    CORE_GET_ROOM_INFO_SUCCESS,

    CORE_GET_ROOM_STATUS_REQUEST,
    CORE_GET_ROOM_STATUS_SUCCESS,

    CORE_LOAD_SUGGEST_INFORMATION_REQUEST,
    CORE_LOAD_SUGGEST_INFORMATION_SUCCESS,

    CORE_GET_FAVORITEROOM_REQUEST,
    CORE_GET_FAVORITEROOM_SUCCESS,

    O365_SUGGESTTION_REQUEST,
    O365_SUGGESTTION_SUCCESS,
    O365_SUGGESTTION_FAILURE,

    O365_SUGGEST_ROOM_MEETING_REQUEST,
    O365_SUGGEST_ROOM_MEETING_SUCCESS,

    CORE_GET_CAN_BOOKING_REQUEST,
    CORE_GET_CAN_BOOKING_SUCCESS,

} from '../../types'
const requestState = 'request'
const initialState = []
const initialStateObj = {}
export default {
    rooms: (state = initialState, action) => {
        switch (action.type) {
            case CORE_SEARCH_ROOM_REQUEST:
            case CORE_LOAD_ROOMS_REQUEST:
                return requestState
            case CORE_SEARCH_ROOM_SUCCESS:
            case CORE_LOAD_ROOMS_SUCCESS:
                if (action.payload)
                    return action.payload
                else return []
            default:
                return state
        }
    },
    roomsSuggest: (state = initialStateObj, action) => {
        switch (action.type) {
            case O365_SUGGEST_ROOM_REQUEST:
                return initialStateObj
            case O365_SUGGEST_ROOM_MEETING_REQUEST:
                return requestState
            case O365_SUGGEST_ROOM_SUCCESS:
            case O365_SUGGEST_ROOM_MEETING_SUCCESS:
                if (action.payload) {
                    let payload = action.payload,
                        value = payload.result[0].roomResults
                    if (value && value.length > 0) return value
                    else return []
                } else return []
            default:
                return state
        }
    },
    roomsSuggesttion: (state = initialStateObj, action) => {
        switch (action.type) {
            case O365_SUGGESTTION_REQUEST:
                return requestState
            case O365_SUGGESTTION_SUCCESS:
                if (action && action.payload && Object.keys(action.payload).length > 0)
                    return action.payload
                else return {}
            case O365_SUGGESTTION_FAILURE:
                return initialStateObj
            default:
                return state
        }
    },
    roomsFavor: (state = initialState, action) => {
        switch (action.type) {
            case CORE_GET_FAVORITEROOM_REQUEST:
                return requestState
            case CORE_GET_FAVORITEROOM_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    room: (state = initialState, action) => {
        switch (action.type) {
            case CORE_GET_ROOM_INFO_REQUEST:
                return {}
            case CORE_GET_ROOM_INFO_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    roomStatus: (state = initialState, action) => {
        switch (action.type) {
            case CORE_GET_ROOM_STATUS_REQUEST:
                return {}
            case CORE_GET_ROOM_STATUS_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    suggestInformation: (state = initialStateObj, action) => {
        switch (action.type) {
            case CORE_LOAD_SUGGEST_INFORMATION_REQUEST:
                return initialStateObj
            case CORE_LOAD_SUGGEST_INFORMATION_SUCCESS:
                if (action.payload)
                    return action.payload
                else return {}
            default:
                return state
        }
    },
    canBooking: (state = false, action) => {
        switch (action.type) {
            case CORE_GET_CAN_BOOKING_REQUEST:
                return false
            case CORE_GET_CAN_BOOKING_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/features/rooms/reducer.js